import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Modal, Row, Col } from 'react-bootstrap';
import { getBookingByGuestId } from '../../../../../../general_redux/calendar/actions';
import Loading from '../../../../../../components/loading';
import EditBooking from '../../../Calendar/components/EditBooking/EditBooking';
import Table from '../../../../../../components/Table';
import { customClassification } from "../../../../../../common/functions/utils";
import styles from '../../guest.module.css';
import { getGuestByBooking } from '../../../../../../general_redux/guest/actions';

function GuestBookingList({ id,guestName }) {
  const bookingList = useSelector(({ calendar }) => calendar && calendar.bookingListByGuest);
  const actionForGetBookingListById = useSelector(({ calendar }) => calendar && calendar.actionForGetBookingListById);
  const dateFormat = useSelector(({ generalSetting }) => generalSetting && generalSetting.setting.dateDisplay);
  const guestDetails = useSelector(({ guests }) => guests && guests?.guestByBooking?.[0]);

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('name');
  const [displayList, setDisplayList] = useState([]);
  const [editFetchDataLoading, setEditFetchDataLoading] = useState(false);
  const [editBooking, setEditBooking] = useState(false);
  const [bookingId, setBookingId] = useState('');
  const dispatch = useDispatch();

  const cols = [
    { lable: 'Check-in', key: 'arrive', isDate: true },
    { lable: 'Check-out', key: 'depart', isDate: true },
    { lable: 'Nights', key: 'nights' },
    { lable: 'Rental', key: 'rentalName' },
    { lable: 'Channel', key: 'source' },
    { lable: 'Total', key: 'price' },
    { lable: 'Status', key: 'paymentStatus' },
    { lable: 'Actions', key: '' },
  ];

  useEffect(() => {
    dispatch(getBookingByGuestId(id));
  }, []);

  useEffect(() => {
    setDisplayList([]);
    bookingList.map((booking) => {
      booking.status !== 'Cancelled' && setDisplayList((displayList) => [...displayList, booking]);
    });
  }, [bookingList]);

  function handleEdit({ id }) {
    dispatch(getGuestByBooking(id));
    setEditFetchDataLoading(true);
    setBookingId(id);
  }

  useEffect(() => {
    if (guestDetails && setEditFetchDataLoading) {
      setEditBooking(true);
      setEditFetchDataLoading(false);
    }
  }, [guestDetails]);

  return (
    <div>
      <Modal
        show={editBooking}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setEditBooking(false);
        }}
      >
        <EditBooking bookingId={bookingId} />
    </Modal>
      <Loading loadingStatus={actionForGetBookingListById.loading} />
      <Loading loadingStatus={editFetchDataLoading} />
      <Container fluid>
        {guestName && (
            <div className={styles.guestName}>{`Contact: ${guestName}`}</div>
        )}
        <Row>
          <Col xs={12} md={10} className={`pt-3`}>
            <Table
              rows={customClassification(displayList, order, orderBy)}
              cols={cols}
              dateFormat={dateFormat.toUpperCase()}
              onEdit={handleEdit}
              order={order}
              setOrder={setOrder}
              orderBy={orderBy}
              setOrderBy={setOrderBy}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
export default GuestBookingList;
